import type { Plan } from "./types";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const PLANS: Plan[] = [
  {
    name: "Day Pass",
    apiType: "DAY_PASS",
    price: [{ amount: 20, unit: "day" }],
    features: [{ text: "membershipPlan.dayPass.1" }, { text: "membershipPlan.dayPass.2" }],
  },
  {
    name: "Virtual Address",
    apiType: "VIRTUAL_ADDRESS",
    price: [
      { amount: 59, unit: "month" },
      { amount: 354, unit: "year", isDiscounted: true },
    ],
    features: [{ text: "membershipPlan.virtualAddress.1" }, { text: "membershipPlan.virtualAddress.2" }],
  },
  {
    name: "Silver",
    apiType: "SILVER",
    price: [
      { amount: 165, unit: "month", isDiscounted: true },
      { amount: 1980, unit: "year", isDiscounted: true },
    ],
    features: [
      { text: "membershipPlan.silver.1" },
      { text: "membershipPlan.silver.2" },
      { text: "membershipPlan.silver.3" },
      { text: "membershipPlan.silver.4" },
      { text: "membershipPlan.silver.5" },
      { text: "membershipPlan.silver.6" },
    ],
  },
];
